import { useParams } from "@tanstack/react-router";
import { DEFAULT_LANG, isLang, type Lang } from "./config";

/** Active language, read from the URL. Falls back to Dutch outside localized routes. */
export function useLang(): Lang {
  const params = useParams({ strict: false }) as { lang?: string };
  return isLang(params.lang) ? params.lang : DEFAULT_LANG;
}
